import 'nightingale-app-console/src';
import Alp from 'alp-node/src';
import router from 'alp-router/src';
import bodyparser from 'alp-body-parser/src';
import createRouter from './createRouter';

if (!process.send) {
  // eslint-disable-next-line no-console
  console.log('Not forked.');
  process.exit(1);
}

const app = new Alp({
  publicPath: `${__dirname}/public/`,
});

// init / config
bodyparser(app);

// middlewares
app.catchErrors();
app.servePublic();
app.use(router(createRouter())(app));

app.start(async () => {
  await app.listen();
});
